// extracted by mini-css-extract-plugin
module.exports = {"dialogWrapper":"styles_dialogWrapper__b5fc3","closeButton":"styles_closeButton__4DCwr"};